import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProveedorUi } from '@xiltrion/ui/proveedor';
import './index.css';
import { router } from './app/routes';
import { SessionProvider } from './app/session';
import { applyTheme } from './app/theme';
import { BrandTheme } from './app/brand';

applyTheme();

// Tras cualquier cambio, los requisitos de la puesta en marcha (y el aviso de la sesión) se vuelven a revisar.
const qc: QueryClient = new QueryClient({
  mutationCache: new MutationCache({ onSuccess: () => { void qc.invalidateQueries({ queryKey: ['setup'] }); void qc.invalidateQueries({ queryKey: ['me'] }); } }),
  defaultOptions: { queries: { staleTime: 15_000, retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ProveedorUi>
      <QueryClientProvider client={qc}>
        <BrandTheme />
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </QueryClientProvider>
    </ProveedorUi>
  </React.StrictMode>,
);
